module.exports = __webpack_public_path__ + "static/media/img_button.b9d55cb2.svg";